export enum EPlatformNoticeRecipientType {
  Store = "Store",
  Courier = "Courier",
  Reseller = "Reseller",
}
